<template>
  <default-layout>
    <event-navbar title="Speaker" />
    <div class="container-fluid">
      <speaker-detail :speakerId="$route.params.speakerId" :eventShortName="$route.params.shortName" />
    </div>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import SpeakerDetail from '@/components/speaker/speaker-detail.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'SpeakerDetailView',
  components: {
    SpeakerDetail, EventNavbar, DefaultLayout
  },
}
</script>
